import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import {
  fetch2FAError,
  fetch2FASuccess,
  submit2FAError,
  submit2FASuccess,
  submitExpiredPassError,
  submitExpiredPassSuccess,
  submitLoginError,
  submitLoginSuccess,
  submitSSOError,
  submitSSOSuccess,
  useOtherCredentialsError,
  useOtherCredentialsSuccess,
  validateSessionError,
  validateSessionSuccess,
} from './actions'
import {
  FETCH_2FA_ASYNC,
  LOGIN_STEPS,
  SUBMIT_2FA_ASYNC,
  SUBMIT_EXPIRED_PASS_ASYNC,
  SUBMIT_LOGIN_ASYNC,
  SUBMIT_SSO_ASYNC,
  USE_OTHER_CREDENTIALS_ASYNC,
  VALIDATE_SESSION_ASYNC,
} from './constants'

const validateSessionEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(VALIDATE_SESSION_ASYNC.INITIATE),
    mergeMap(() =>
      api.login.validateSession().pipe(
        map((response) => validateSessionSuccess(response)),
        catchError((error) => of(epicsErrorHandler(validateSessionError, error)))
      )
    )
  )

const useOtherCredentialsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(USE_OTHER_CREDENTIALS_ASYNC.INITIATE),
    mergeMap(() =>
      api.login.useOtherCredentials().pipe(
        map((response) => useOtherCredentialsSuccess(response)), // eslint-disable-line react-hooks/rules-of-hooks -- action creator, not a hook
        catchError((error) => of(epicsErrorHandler(useOtherCredentialsError, error)))
      )
    )
  )

const submitLoginEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_LOGIN_ASYNC.INITIATE),
    mergeMap((action) =>
      api.login.submitLogin(action.payload.body).pipe(
        map(({ response }) => submitLoginSuccess(response)),
        catchError((error) => of(epicsErrorHandler(submitLoginError, error)))
      )
    )
  )

const submitExpiredPassEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_EXPIRED_PASS_ASYNC.INITIATE),
    mergeMap((action) =>
      api.login.submitExpiredPass(action.payload.body).pipe(
        map(({ response }) => submitExpiredPassSuccess(response)),
        catchError((error) => of(epicsErrorHandler(submitExpiredPassError, error)))
      )
    )
  )

const submitSSOEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_SSO_ASYNC.INITIATE),
    mergeMap((action) =>
      api.login.submitSSO(action.payload.body).pipe(
        map(({ response }) => submitSSOSuccess(response)),
        catchError((error) => of(epicsErrorHandler(submitSSOError, error)))
      )
    )
  )

const fetch2FAEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_2FA_ASYNC.INITIATE),
    mergeMap(() =>
      api.login.fetch2FA().pipe(
        map((response) => fetch2FASuccess(response)),
        catchError((error) => of(epicsErrorHandler(fetch2FAError, error)))
      )
    )
  )

const submit2FAEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_2FA_ASYNC.INITIATE),
    mergeMap((action) =>
      api.login.submit2FA(action.payload.body).pipe(
        map(({ response }) => submit2FASuccess(response)),
        catchError((error) => of(epicsErrorHandler(submit2FAError, error)))
      )
    )
  )

const stepChangeEpic = (action$) =>
  action$.pipe(
    ofType(
      VALIDATE_SESSION_ASYNC.SUCCESS,
      SUBMIT_LOGIN_ASYNC.SUCCESS,
      SUBMIT_EXPIRED_PASS_ASYNC.SUCCESS,
      SUBMIT_SSO_ASYNC.SUCCESS,
      SUBMIT_2FA_ASYNC.SUCCESS
    ),
    mergeMap((action) =>
      of(() => {
        if (action.payload.data.step === LOGIN_STEPS.LOGGED && action.payload.data.redirectTo) {
          window.location = action.payload.data.redirectTo
        }
      })
    )
  )

export default combineEpicsIsolated(
  validateSessionEpic,
  useOtherCredentialsEpic,
  submitLoginEpic,
  submitExpiredPassEpic,
  submitSSOEpic,
  fetch2FAEpic,
  submit2FAEpic,
  stepChangeEpic
)
